import { useContext } from 'react';
import LocationContext from 'App/contexts/location/LocationContext';

export const useLocationData = () => {
  return useContext(LocationContext);
};
